module.exports = __webpack_public_path__ + "static/media/eu-sklad-logo-s.86afcb7d.jpg";